import { AppThunkAction } from "../../../../shared/infrastructure/store/store";
import { userService } from "../../services/dependency.injection";

function logout(history: any): AppThunkAction {
    return async (dispatch, getState) => {
        const response = await userService.logoutService();

        if (response.isRight()) {
            history.replace("/")
        }
    }
}

export default logout;